module.exports = __webpack_public_path__ + "img/mgc-pic.93b57259.png";